<template>
    <div class="text-start">
        <!-- Front & Back the same with 1 option -->
        <template v-if="optionType == '(Same as front tyre)' && Object.keys(option).length == 1">
            <p class="tyre_size_text bold">Your front &amp; rear tyre sizes are the same.</p>
            <p class="tyre_size_text">You may add as many tyres that you need for your order and they will fit either side of your car.</p>
        </template>
        <!-- Front and Back the same with multiple options -->
        <template v-else-if="optionType == '(Same as front tyre)' && Object.keys(option).length > 1">
            <p class="tyre_size_text bold">Your front &amp; rear tyre sizes are the same with several options.</p>
        </template>
        <!-- Different Front and Back sizes with multiple options -->
        <template v-else-if="optionType != '(Same as front tyre)' && Object.keys(option).length > 1">
            <p class="tyre_size_text bold">You have several tyre options available.</p>
            <p class="tyre_size_text">If you wish to add front &amp; rear tyres in one order you will be given the option to add the other after your first tyre choice.</p><br>
        </template>
        <!-- Different Front and Back sizes with 1 option -->
        <template v-else-if="optionType != '(Same as front tyre)' && Object.keys(option).length == 1">
            <p class="tyre_size_text bold">Your front &amp; rear tyres are different sizes.</p>
            <p class="tyre_size_text">If you wish to add front &amp; rear tyres in one order you will be given the option to add the other after your first tyre choice.</p><br>
        </template>
    </div>
</template>

<script>
    export default {
        props: ['optionType', 'option']
    }
</script>

<style lang="scss" scoped>

</style>